import Renderer from "./utils/Renderer.js";
import Funnel from "../services/funnel-service.js";
import Utils from "../services/utils-service.js";
// import cssVariables from '../../../sass/template-set/tacqu_v3/variables.scss';

const template = `
<aside class="progress-container" role="complementary">
    
    <transition name="slide" enter-active-class="slideDown" mode="out-in">
        <header class="fixed" id="top-header-container" style="left:0;" v-if="hasHeader && !fs.isMobile()"  v-cloak>
            <div class="grid">
                <div id="header-left" :class="TopHeaderBaseLogoClasses">
                    <a :href="computed_base_logo_link" v-if="base_logo && custom_template_data.base_logo_link">
                        <img :src="base_logo" class="base-logo" :alt="base_logo_alt"/>
                    </a>
                    <img v-else :src="base_logo" class="base-logo" :alt="base_logo_alt"/>

                    <i class="divider" v-if="partner_logo"></i>

                    <a :href="computed_partner_logo_link" v-if="partner_logo && custom_template_data.partner_logo_link">
                        <img :src="partner_logo" class="logo" :style="partnerLogoStylesHeader" />
                    </a>
                    <img v-if="partner_logo" :src="partner_logo" class="partner-logo" :alt="partner_logo_alt" :style="partnerLogoStylesHeader">
                </div>
                
                <div id="header-mid" :class="TopHeaderMidClasses" ></div>
                <div id="header-right" class="s12 m4 l3 clm">
					<div class="call-in">
                        <p>{{talkItOut('header_cta_1')}}</p>
                        <p>
                            <strong>
                                {{talkItOut('header_cta_2')}} 
                                <a :href="'tel:'+talkItOut('phone')">   
                                    {{talkItOut('phone')}}
                                </a>
                            </strong>
                        </p>
					</div>
                </div>
            </div>
        </header>
    </transition>


     <transition name="slide" enter-active-class="slideDown" mode="out-in">
        <header class="fixed" id="progress-header" :style="progressHeaderStyles" v-if="fs.isMobile() && !browser_reload"  v-cloak>
            <div class="grid collapse" >
                <div class="s2 clm">
                    <a class="show-progress" name="progress-bar-show" @click="toggleProgress()" aria-label="Show progress">
                        <span class="iconic" data-glyph="menu" title="menu" aria-hidden="true"></span>
                    </a>
                </div>

                <div :class="partner_logo ? 's4 clm' : 's8 clm' " >
                    <a :href="computed_base_logo_link" v-if="base_logo && custom_template_data.base_logo_link">
                        <img :src="base_logo" class="base-logo" :style="baseLogoStyles" :alt="base_logo_alt" />
                    </a>
                    <img v-else :src="base_logo" class="base-logo" :style="baseLogoStyles" :alt="base_logo_alt"/>
                </div>
                <div :class="partner_logo && base_logo ? 's4 clm' : 's8 clm' " v-if="partner_logo">
                    <a :href="computed_partner_logo_link" v-if="partner_logo && custom_template_data.partner_logo_link">
                        <img :src="partner_logo" class="logo" :style="partnerLogoStyles"/>
                    </a>
                    <img v-else :src="partner_logo" class="partner-logo" :style="partnerLogoStyles" :alt="partner_logo_alt"/>
                </div>



                <div class="s2 clm completeness" :style="!showProgress ? 'opacity: 1' : 'opacity: 0' " >
                    <h4 class="text-center completeness-text">
                        <span class="done">{{displayNumber}}%</span> <br>
                        <small>Complete</small>
                    </h4>
                </div>
            </div>
        </header>
    </transition>
    <div class="grid scrollbar" id="progress-tray" :style="showProgressFUN()" >

        <div class="s12 clm " v-if="!fs.isMobile() && !hasHeader">

            <a :href="computed_base_logo_link" v-if="base_logo && custom_template_data.base_logo_link && !hasHeader" >
                <img v-if="base_logo" v-show="!browser_reload" :src="base_logo" class="base-logo" :alt="base_logo_alt" :style="baseLogoStyles"/>
            </a>
            <img v-if="base_logo && !custom_template_data.base_logo_link && !hasHeader" v-show="!browser_reload" :src="base_logo" class="base-logo" :style="baseLogoStyles" :alt="base_logo_alt"/>

            <a :href="computed_partner_logo_link" v-if="partner_logo && custom_template_data.partner_logo_link">
                <img v-if="partner_logo" v-show="!browser_reload" :src="partner_logo" class="logo" :style="partnerLogoStyles" :alt="partner_logo_alt"/> 
            </a>
            <img v-if="partner_logo && !custom_template_data.partner_logo_link" v-show="!browser_reload" :src="partner_logo" class="logo" :style="partnerLogoStyles" :alt="partner_logo_alt"/> 

        </div>
        <div class="s12 center clm "  v-show="!fs.isMobile() && !talkItOut('has_header')">
            <transition name="fade" mode="out-in">
                <div class="talk-it-out"  v-show="showTalkItOut">
                    <span aria-hidden="true">
                        <img class="icon iconic iconic-md call-icon" alt="Phone icon" :src="talkItOut('icon_url')">
                    </span>
                    {{talkItOut('title')}} <br />
                    Call us <a :aria-label="'Call us at '+ talkItOut('phone')" :href="'tel:'+talkItOut('phone')">{{talkItOut('phone')}}</a>
                </div>
            </transition>
        </div>
        <div class="s12 clm" v-show="!browser_reload">
            <div class="progress-bar donut " >
                <div aria-live="polite" aria-atomic="true" class="sr-only" id="progress_announcer" ref="progress_announcer"></div>
                <h2>
                    <span class="done" >{{displayNumber}}%</span> 
                    <br>
                    <small>Complete</small>
                </h2>
                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="160" width="160" viewBox="0 0 200 200" data-value="40" >
                  <path style="stroke-width:10px" class="bg" stroke="#ccc" d="M55 159.5a77 77 0 1 1 90.93 0"  fill="none" stroke-linecap="round"/>
                  <path style="stroke-width:10px" ref="meter" class="meter" stroke="#09c" d="M55 159.5a77 77 0 1 1 90.93 0" fill="none" :stroke-dasharray="isLobSelected ? donutVal: 387" stroke-dashoffset="387" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        <div class="s12 center clm talk-it-out-container" v-if="fs.isMobile()">
            <transition name="fade" mode="out-in">
                <div class="talk-it-out" v-show="showTalkItOut">
                    <span aria-hidden="true">
                        <img class="icon iconic iconic-md call-icon" alt="Phone icon" :src="talkItOut('icon_url')">
                    </span>
                    {{talkItOut('title')}} <br />
                    Call us <a :href="'tel:'+talkItOut('phone')">{{talkItOut('phone')}}</a>
                </div>
            </transition>
        </div>
        <div class="s12 clm progress-breadcrumbs" v-show="!browser_reload" >
            <section aria-label="Breadcrumb section that shows completed, current, and next pages.">
                <ul class="no-bullet progress-item-container">
                    <transition-group name="slideLeft"  leave-active-class="fadeUp" mode="out-in">
                        <li class="s12 clm"  key="-1" v-if="!isLobSelected && !loading.status">
                            <p class="text-center white" style="margin-top: 50%;">{{talkItOut('no_lob_text')}}</p>
                        </li>
                        <li v-for="(fx, pi) in funnel.idsMap.experiences" :class="item_class(funnel.elements[fx])" class="progress-item" :key="'fx-'+pi" :id="fx" v-if="fs.display(funnel.elements[fx])">
                            <span>{{funnel.elements[fx].name}}</span>
                            <ul  v-if="fs.display(funnel.elements[fx].categories)" class="progress-sub-item-container">
                                <li v-for="(cat, c) in funnel.elements[fx].categories.sequence" :key="c - 1" :class="item_class(funnel.elements[cat])" :id="cat" style="margin-bottom:0;padding-top:0" class="progress-sub-item">
                                    <span v-if="funnel.elements[cat].type == 'qty'">{{funnel.elements[cat].name}}: {{funnel.elements[cat].value}}</span>
                                    <span v-else>{{funnel.elements[cat].name}}</span>
                                </li>
                            </ul>
                        </li>
                    </transition-group>
                </ul>
            </section>
        </div>

        <div class="s12 clm checkout" v-for="(featId, i) in funnel.idsMap.sidebar_features" :id="featId" v-if="fs.display(funnel.elements[featId])">
            <ul>
                <li v-for="(cart, ci) in funnel.elements[featId].quotes" :key="'cart-'+ci" class="s12 clm care-plan">
                    <span class="text-left">{{cart.title}}</span>
                    <ul class="table coverage-table">
                        <li v-for="(item, itm) in cart.items" :key="'cart-item-'+itm" class="tr">
                            <div class="td td6 text-left">
                                <span>{{item.label}}</span>
                            </div>
                            <div class="td td6 text-right">
                                <span>{{item.value}}</span>
                            </div>
                        </li>
                    </ul>
                </li>

                <li v-for="(summary, si) in funnel.elements[featId].summary" :key="'cart-summary-'+si" :id="'cart-summary-'+si" class="s12 clm cart-summary">
                    <span class="text-left left">{{summary.label}}</span> <span class="text-right right">{{summary.value}}</span>
                </li>
            </ul>
        </div>
    </div>
    <div v-if="fs.isMobile() && showProgress" class="outside-overlay" v-on:click="toggleProgress" aria-label="Close progress"></div>
</aside>
`;

export default {
    name: 'b-progress',
    template,
    components: {
        'renderer': Renderer, 
    },
    data() {
        return {
            displayNumber: 0,
            interval: false,
            showProgress: false,
            browser_reload:true,
        }
    },
    watch: {
        "window":{
            handler: function(newVal, oldVal){
                var root = document.getElementById( 'html-tag' );
                    this.showProgress = false
                    root.classList.remove("no-scroll");
                    document.body.classList.remove("no-scroll");
            },
            deep:true
            
        },
        "loading.status"(newVal){
            if (!newVal) {
                this.browser_reload = false
            }
        },
        //Added condition to stop progress bar at 100---AMS 
        "displayNumber"(newVal){
            if (newVal >= 100) {
                return 100
            }
        },
        complete_percent(newVal, oldVal) {
            var self=this
            clearInterval(self.interval);

            console.log(this.complete_percent, this.displayNumber);
            if(this.complete_percent == this.displayNumber || !this.isLobSelected) {
                return;
            }

            this.interval = window.setInterval(() => {
                if(this.displayNumber != this.complete_percent) {
                    var change = (this.complete_percent - this.displayNumber) / 10;
                    change = change >= 0 ? Math.ceil(change) : Math.floor(change);
                    this.displayNumber = this.displayNumber + change;
                    
                    if (this.active_page.indexOf("pg_rtq") > -1) {
                        this.displayNumber = 100;
                    }
                }else {
                    // Once the complete_percent is reached, clear the interval
                    clearInterval(self.interval);
                    $('#progress_announcer').text('Page Loaded: '+this.active_page_title+' - Application progress: '+this.displayNumber+'%' ) 
                }
            }, 20);
        },
        showProgress: function (newVal) {
            var root = document.getElementById( 'html-tag' );
            if (this.fs.isMobile() && newVal) {
                root.classList.add("no-scroll");
                document.body.classList.add("no-scroll");
            } else {
                root.classList.remove("no-scroll");
                document.body.classList.remove("no-scroll");
            }
        }
    },
    
    computed: {
        ...Vuex.mapGetters([
            'funnel',
            'active_page',
            'active_page_uid',
            'vehicles',
            'complete_percent',
            'factory',
            'loading',
            'progress',
            'window',
            'template_set',
            'partner_logo',
            'base_logo',
            'partner_logo_alt',
            'base_logo_alt',
            'custom_template_data'
        ]), 
        TopHeaderBaseLogoClasses: function(){
            var classes = []
            if(this.partner_logo){
                classes.push("partner s6 l4 clm")
            }else{
                classes.push("s12 m3 l3 clm")
            }
            return classes
        },
        TopHeaderMidClasses: function(){
            var classes = []
            if(this.partner_logo && this.base_logo){
                classes.push("s12 m2 l5 clm")
            }else{
                classes.push("s12 m5 l6 clm")
            }
            return classes
        },
        hasHeader: function(){
            // console.log('has header: '+ this.talkItOut('has_header'));
            return this.talkItOut('has_header')
        },
        computed_base_logo_link:function(){
            let baseLogoLink =  ''

            if (this.talkItOut('base_logo_link')) {
                baseLogoLink = this.talkItOut('base_logo_link')
            }
            if (this.custom_template_data.base_logo_link == 'site_url') {
                baseLogoLink = site_url+'?MDRefCode='+mdrc
            }else{
               if (!this.custom_template_data.base_logo_link == '' ) {
                baseLogoLink = this.custom_template_data.base_logo_link
               } 
               baseLogoLink = this.custom_template_data.base_logo_link
            }
            return baseLogoLink
        },
        computed_partner_logo_link:function(){
            if (this.custom_template_data.partner_logo_link == 'site_url') {
                return site_url+'?MDRefCode='+mdrc
            }else{
               if (!this.custom_template_data.partner_logo_link == '' ) {
                return this.custom_template_data.partner_logo_link
               } 
               return this.custom_template_data.partner_logo_link
            }
        },
        progressHeaderStyles: function(){
            if (this.fs.isMobile()) {
                // var tw = this.factory.css_variables.trayWidth+'px';
                var tw = '300px'
                return !this.showProgress ? 'margin-left: 0' : 'margin-left:'+ tw;
            }
            
        },
        active_page_title: function () {
            if (this.funnel.elements[this.active_page_uid]) {
                if (!this.funnel.elements[this.active_page_uid].page_title) {
                    return this.funnel.elements[this.active_page_uid].meta_description
                }
                return this.funnel.elements[this.active_page_uid].page_title
            }
        },
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        donutVal: function () {

            var zero = 387
            var percentageCompleteFraction = this.complete_percent * .01;
            var addition = 365 * percentageCompleteFraction
            var val = zero + addition;

            if (percentageCompleteFraction == 1  || this.active_page.indexOf("pg_rtq") > -1) {
                return 775
            }
            if(!percentageCompleteFraction == NaN || !percentageCompleteFraction){
                return zero
            }
            return parseInt(val)
        },
        isLobSelected: function () {
            var selected = false;
            const insType = this.funnel.elements["in_insurance_type"];
            if (!Utils.isEmpty(insType) && !Utils.isObjEmpty(insType.value)) {
                selected = true;
            }
            return selected;
        },
        baseLogoStyles: function(){
            if (!this.browser_reload) {
                var styles = []
                console.log(this.partner_logo, this.base_logo);
                //if has partner logo
                //need to add support for custom template data styles -G
                if (this.partner_logo) {
                    styles.push('padding:7px 15px 7px 0')
                }
                //if base logo is not svg 
                if (this.base_logo.indexOf('.svg') == -1) {
                    styles.push('object-fit: contain')
                }
                if(this.hasHeader){
                    styles.push('max-width:300px')
                }
                return styles.join('; ')
            }
        },
        partnerLogoStyles: function(){
            if (!this.browser_reload) {
                var styles = []
                //if partner logo is not svg
                //padding styles moved to the progress css 
                //need to add support for custom template data styles -G
                // custom_template_data

                // if (this.custom_template_data.logo_style_enroll) {
                //     styles.push(this.custom_template_data.logo_style_enroll)
                // }

                //^^^^ this part is commented out until we cleanup old recodes that have this variable. For example Mercer ASME -G 
                
                if (this.partner_logo.indexOf('.svg') == -1) {
                    styles.push('object-fit: contain')
                }
                return styles.join('; ')
            }
        },
        partnerLogoStylesHeader: function(){
            if (!this.browser_reload) {
                var styles = []
                //if partner logo is not svg
                //padding styles moved to the progress css 
                //need to add support for custom template data styles -G
                // custom_template_data

                if (this.custom_template_data.logo_style_enroll_header) {
                    styles.push(this.custom_template_data.logo_style_enroll_header)
                }
                
                if (this.partner_logo.indexOf('.svg') == -1) {
                    styles.push('object-fit: contain')
                }
                return styles.join('; ')
            }
        },
        showTalkItOut: function () {
            if (this.browser_reload && !this.custom_template_data) {
                // ctd is not loaded yet here so we should return and try again -G
                return;
            }
            if (this.custom_template_data.suppress_phone_before_leads && !this.factory.complete_pages.includes('pg_basic_info')) {
              return;
            } 
            
            return true
        }
    },
    mounted: function () {
        this.displayNumber = this.complete_percent ? this.complete_percent : 0;
        
    },
    methods: {
        
        talkItOut: function(item) {
            if(Object.keys(this.funnel.elements).length > 0){
                return this.funnel.elements["sc_talk_it_out"][item];
            }
        },
        showProgressFUN: function () {
            // var tw = this.factory.css_variables.trayWidth+'px';
            var tw = '300px'
            // var gutter = this.factory.css_variables.gutter;
            var gutter = '30px'
            
            if (this.fs.isMobile() && !this.showProgress) {
                console.log("is mobile progress.js");
                return 'margin-left: calc(-'+tw+' - '+gutter+')'
            }
            else {
                if (this.hasHeader) {
                    return "padding-top: 150px; margin-left: 0"
                }
                return "margin-left: 0"
            }
        },
        toggleProgress: function () {
            this.showProgress = !this.showProgress
        },
        item_class: function (item) {
            var state_classes = [];
            Object.keys(item.states).map(function (state) {
                // console.log(state);
                if (item.states[state]) {
                    state_classes.push(state)
                }
            });
            return item.name.replace(/\s+/g, '-').toLowerCase() + ' ' + state_classes + ' ' + item.class;
        }
       
    }
};